var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.modo === "firmar" && _vm.$store.getters.hasAnyRole(["empleado"])
      ? _c(
          "div",
          {
            staticClass: "box column is-10",
            staticStyle: {
              "background-color": "hsl(229, 53%, 96%)",
              padding: "12px",
            },
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", { staticClass: "columns is-vcentered" }, [
              _vm._m(1),
              _vm._v(" "),
              _c("div", { staticClass: "column is-5" }, [
                _c(
                  "div",
                  {
                    staticClass: "dropdown is-fullwidth",
                    class: { "is-active": _vm.isOpen },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "dropdown-trigger",
                        staticStyle: { width: "100%" },
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass:
                              "button is-fullwidth is-flex is-justify-content-flex-start",
                            on: { click: _vm.toggleDropdown },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(
                                  _vm.firmadorSelected
                                    ? _vm.firmadorSelected.titulo
                                    : "Elegí una opción"
                                )
                              ),
                            ]),
                            _vm._v(" "),
                            _vm._m(2),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "dropdown-menu" }, [
                      _c(
                        "div",
                        { staticClass: "dropdown-content" },
                        _vm._l(
                          _vm.firmadoresDisponibles.filter(
                            (option) => option.visible
                          ),
                          function (option) {
                            return _c(
                              "a",
                              {
                                key: option.id,
                                staticClass: "dropdown-item",
                                class: { "is-disabled": option.disabled },
                                on: {
                                  click: function ($event) {
                                    !option.disabled && _vm.selectOption(option)
                                  },
                                },
                              },
                              [
                                _c("div", [
                                  _c("i", { class: option.icono }),
                                  _vm._v(" "),
                                  _c("strong", [_vm._v(_vm._s(option.titulo))]),
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "has-text-grey is-size-7" },
                                  [_vm._v(_vm._s(option.subTitulo))]
                                ),
                                _vm._v(" "),
                                _c("hr", { staticClass: "dropdown-divider" }),
                              ]
                            )
                          }
                        ),
                        0
                      ),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "column is-3" }, [
                _c(
                  "button",
                  {
                    staticClass: "button is-primary is-fullwidth",
                    attrs: { disabled: !_vm.firmadorHabilitado() },
                    on: {
                      click: function ($event) {
                        return _vm.confirmFirmar()
                      },
                    },
                  },
                  [
                    _c("i", { staticClass: "fas fa-upload fa-fw" }),
                    _vm._v(" Firmar Recibos"),
                  ]
                ),
              ]),
            ]),
          ]
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "box" },
      [
        _c("h2", { staticClass: "title is-4" }, [
          _vm._v("Recibos Pendientes de firma"),
        ]),
        _vm._v(" "),
        _c(
          "b-table",
          {
            class:
              _vm.recibosPend.length > 0 ? "cursor-pointer" : "cursor-default",
            attrs: {
              data: _vm.recibosPend,
              bordered: false,
              narrowed: false,
              hoverable: true,
              loading: _vm.isLoading,
              "mobile-cards": true,
              sortable: true,
            },
            on: { dblclick: _vm.goToDocument, check: _vm.checkRow },
            scopedSlots: _vm._u([
              {
                key: "empty",
                fn: function () {
                  return [
                    _c(
                      "div",
                      { staticClass: "is-family-monospace has-text-centered" },
                      [
                        _vm.isLoading
                          ? _c("span")
                          : _c("span", [
                              _vm._v(
                                "No hay recibos que cumplan con los filtros de busqueda"
                              ),
                            ]),
                      ]
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
          },
          [
            _c("b-table-column", {
              attrs: { field: "nombre", label: "Recibo", sortable: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _c("span", { staticClass: "break-word" }, [
                        _c("i", { staticClass: "fas fa-dollar-sign" }),
                        _vm._v("  " + _vm._s(props.row.nombre)),
                      ]),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _vm.$store.getters.hasAnyRole(["lyris", "empleador"])
              ? _c("b-table-column", {
                  attrs: {
                    field: "empleado.usuario.apellido",
                    sortable: "",
                    label: "Empleado",
                  },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "default",
                        fn: function (props) {
                          return [
                            _vm._v(
                              "\n          " +
                                _vm._s(props.row.empleado.usuario.apellido) +
                                ", " +
                                _vm._s(props.row.empleado.usuario.nombre) +
                                "\n        "
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2108481655
                  ),
                })
              : _vm._e(),
            _vm._v(" "),
            !_vm.esSignarV3
              ? [
                  _c("b-table-column", {
                    attrs: {
                      field: "estado",
                      label: "Conformidad",
                      sortable: "",
                      centered: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c("span", [
                                _c("i", {
                                  staticClass: "fas",
                                  class: _vm.getConformidadIcon(
                                    props.row.estado
                                  ),
                                }),
                              ]),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4276283669
                    ),
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm.$store.getters.hasAnyRole(["empleado"]) && _vm.esSignarV3
              ? [
                  _c("b-table-column", {
                    staticStyle: { padding: "4px" },
                    attrs: {
                      field: "estadoConformidad",
                      label: "Conformidad",
                      centered: "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (props) {
                            return [
                              _c(
                                "div",
                                {
                                  staticStyle: {
                                    display: "flex",
                                    "align-items": "center",
                                    gap: "8px",
                                  },
                                },
                                [
                                  _c("i", {
                                    staticClass: "fas",
                                    class: _vm.getConformidadIconSelect(
                                      props.row.estadoConformidad
                                    ),
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "b-select",
                                    {
                                      class: {
                                        "select-verde":
                                          props.row.estadoConformidad ===
                                          "En Conformidad",
                                        "select-rojo":
                                          props.row.estadoConformidad ===
                                          "En Disconformidad",
                                      },
                                      attrs: {
                                        placeholder: "Seleccionar",
                                        size: "is-small",
                                      },
                                      model: {
                                        value: props.row.estadoConformidad,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            props.row,
                                            "estadoConformidad",
                                            $$v
                                          )
                                        },
                                        expression:
                                          "props.row.estadoConformidad",
                                      },
                                    },
                                    [
                                      _c(
                                        "option",
                                        { attrs: { value: "En Conformidad" } },
                                        [_vm._v("En Conformidad")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "option",
                                        {
                                          attrs: { value: "En Disconformidad" },
                                        },
                                        [_vm._v("En Disconformidad")]
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1361157688
                    ),
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: {
                field: "fecha",
                label: "Fecha",
                sortable: "",
                centered: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(
                            _vm._f("moment")(
                              new Date(props.row.fecha),
                              "DD/MM/YYYY"
                            )
                          ) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
            _vm._v(" "),
            _c("b-table-column", {
              attrs: { label: "Tipo", centered: "" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        "\n          " +
                          _vm._s(props.row.tipo_recibo.nombre) +
                          "\n        "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          2
        ),
        _vm._v(" "),
        _c(
          "infinite-loading",
          {
            attrs: { identifier: _vm.identifierLoaderDocuments },
            on: { infinite: _vm.infiniteHandlerDocuments },
          },
          [
            _c(
              "div",
              {
                staticClass: "py-5 is-size-7 is-family-monospace",
                attrs: { slot: "no-more" },
                slot: "no-more",
              },
              [
                _vm.isLoading
                  ? _c("span", [_vm._v("Cargando...")])
                  : _c("span", [_vm._v("~ Fin del listado ~")]),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "py-5 is-size-7 is-family-monospace",
                attrs: { slot: "no-results" },
                slot: "no-results",
              },
              [
                _vm.isLoading
                  ? _c("span", [_vm._v("Cargando...")])
                  : _c("span", [_vm._v("~ Fin del listado ~")]),
              ]
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c(
      "h1",
      {
        staticClass:
          "title is-4 is-flex is-justify-content-space-between is-align-items-center",
        staticStyle: { "margin-bottom": "12px" },
      },
      [_c("span", [_vm._v("Opciones para empleado")])]
    )
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "column is-narrow" }, [
      _c("h3", { staticClass: "subtitle is-6 column-is-2" }, [
        _vm._v("Seleccione el firmador a utilizar:"),
      ]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("span", { staticClass: "icon is-small ml-auto" }, [
      _c("i", {
        staticClass: "fas fa-angle-down",
        attrs: { "aria-hidden": "true" },
      }),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }